export var ArrowKeyNavigationType = /*#__PURE__*/function (ArrowKeyNavigationType) {
  ArrowKeyNavigationType["COLOR"] = "color";
  ArrowKeyNavigationType["MENU"] = "menu";
  return ArrowKeyNavigationType;
}({});